import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";

const Forbidden = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="403"
      title={
        <span style={{ fontSize: 30, fontWeight: 600 }}>
          Không có quyền truy cập
        </span>
      }
      subTitle={
        <span style={{ fontSize: 18, fontWeight: 500 }}>
          Bạn không có quyền truy cập vào trang này. Vui lòng liên hệ quản trị
          viên nếu cần hỗ trợ.
        </span>
      }
      extra={
        <Button type="primary" onClick={() => navigate("/", { replace: true })}>
          Về trang chủ
        </Button>
      }
    />
  );
};

export default Forbidden;
